import { useMemo, useState } from 'react'
import { Modal } from '@/src/components/ui/Modal/Modal'
import { DurationInput } from '@/src/components/ui/DurationInput/DurationInput'
import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'
import styles from './AutoDistributionModal.module.css'

interface AutoDistributionModalProps {
  isOpen: boolean
  onCancel: () => void
  onSubmit: (params: { groupCount: number; durationSeconds?: number }) => void
}

export function AutoDistributionModal({ isOpen, onCancel, onSubmit }: AutoDistributionModalProps) {
  const [groupCount, setGroupCount] = useState<number | ''>('')
  const [durationSeconds, setDurationSeconds] = useState<number>(0)
  const [durationUnit, setDurationUnit] = useState<'seconds' | 'minutes'>('minutes')
  const [error, setError] = useState<string>('')
  const { primary_color, text_primary_color } = useAppSelector(selectBranding)

  const isValid = useMemo(() => {
    if (groupCount === '' || !Number.isFinite(groupCount)) return false
    return Number(groupCount) > 0
  }, [groupCount])

  const footer = (
    <div className={styles.footer}>
      <button className="lk-button lk-button-secondary" onClick={onCancel}>
        Отмена
      </button>
      <button
        className="lk-button"
        style={{
          backgroundColor: primary_color || '#6366f1',
          color: text_primary_color || '#fff',
        }}
        onClick={() => {
          if (!isValid) {
            setError('Укажите корректное количество групп')
            return
          }
          setError('')
          onSubmit({
            groupCount: Number(groupCount),
            durationSeconds: durationSeconds > 0 ? durationSeconds : undefined,
          })
        }}
        disabled={!isValid}
      >
        Создать и распределить автоматически
      </button>
    </div>
  )

  return (
    <Modal
      isOpen={isOpen}
      onCancel={onCancel}
      title={<span className={styles.title}>Автораспределение</span>}
      footer={footer}
      className={styles.modal}
    >
      <div className={styles.content}>
        <label className={styles.field}>
          <span>Количество групп (обязательно)</span>
          <input
            type="number"
            min={1}
            placeholder="Например, 3"
            value={groupCount === '' ? '' : groupCount}
            onChange={(e) => {
              const raw = e.target.value
              // Если поле пустое или ввели только "0" - очищаем
              if (raw === '' || raw === '0') {
                setGroupCount('')
                return
              }
              const v = parseInt(raw, 10)
              if (!Number.isNaN(v) && v > 0) {
                setGroupCount(v)
              }
            }}
            className={styles.input}
          />
        </label>

        <DurationInput
          value={durationSeconds}
          unit={durationUnit}
          onChange={(seconds, _raw, unit) => {
            setDurationSeconds(seconds)
            setDurationUnit(unit)
          }}
          label="Длительность (необязательно)"
          className=""
        />

        {error && <div className={styles.error}>{error}</div>}
      </div>
    </Modal>
  )
}


